import useSelectionStore from "@/use-selection-store";

const useSelectionEffects = () => {
  const setSelection = useSelectionStore((store) => store.setSelection);

  return { setSelection };
};

export default useSelectionEffects;
